import { useEffect, useState } from 'react';
import { getTenantId } from '../api/tenantHeader.ts';
import apiService from '../services/apiService.ts';

export const useSpaces = (locationId:string) => {
  const [resolvedLocationId, setResolvedLocationId] = useState('');
  const effectiveLocationId = locationId || localStorage.getItem('saSelectedLocation') || resolvedLocationId;
  const [rows,setRows]=useState<any[]>([]);
  const [loading,setLoading]=useState(false);

  const fetchData=async()=>{
    let nextLocationId = effectiveLocationId;
    if (!nextLocationId) {
      const focusedTenantId = getTenantId();
      if (!focusedTenantId) {
        setRows([]);
        return;
      }
      const locations = await apiService.getLocations(String(focusedTenantId));
      const firstLocationId = Array.isArray(locations) && locations[0]?.id
        ? String(locations[0].id)
        : '';
      if (!firstLocationId) {
        setRows([]);
        return;
      }
      localStorage.setItem('saSelectedLocation', firstLocationId);
      localStorage.removeItem('saSelectedSpace');
      setResolvedLocationId(firstLocationId);
      nextLocationId = firstLocationId;
    }
    setLoading(true);
    try{
      const data=await apiService.getSpaces(nextLocationId);
      setRows(Array.isArray(data) ? data : []);
    }finally{setLoading(false);}
  };

  useEffect(()=>{
    if (locationId) {
      localStorage.setItem('saSelectedLocation', locationId);
    }
    fetchData();
  },[locationId, effectiveLocationId]);

  return { rows, loading, refetch: fetchData };
};
